import LzMBase, { LzNBase } from "./Base";
import LzMRights, { LzTRights } from "./Rights";

export interface LzNRole extends LzNBase {
    name: string,
    rights: LzTRights,
}

class LzMRole extends LzMBase implements LzNRole {
    name: string;
    rights: LzTRights;

    constructor(model?: LzNRole, copyAll?: boolean) {
        super(model, copyAll);

        this.name = model?.name || '';
        this.rights = model?.rights || null;
    }

    checkRights(action: string): boolean {
        return LzMRights.checkRight(this.rights, action);
    }

    reParseRights(): void {
        LzMRights.reParseRights(this.rights, true);
    }
}

export default LzMRole;
